<template>
  <div
    v-if="entries.length > 0"
    class="customer-custom-field-list"
  >
    <!-- インライン表示: 検索結果リスト等で常時可視 -->
    <div
      v-if="inline"
      class="d-flex flex-wrap"
      style="gap: 4px 12px;"
    >
      <div
        v-for="entry in entries"
        :key="`ccf-inline-${entry.id}`"
        class="text-caption"
      >
        <span class="text--secondary">{{ entry.name }}:</span>
        <span class="ml-1">{{ entry.value }}</span>
      </div>
    </div>

    <!-- 折りたたみ表示: 紐付け済み顧客カード等で省スペース -->
    <v-expansion-panels
      v-else
      flat
      multiple
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="py-1 px-2 text-caption">
          カスタム情報 ({{ entries.length }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            v-for="entry in entries"
            :key="`ccf-${entry.id}`"
            class="d-flex text-caption py-1"
            style="gap: 8px;"
          >
            <span class="text--secondary">{{ entry.name }}:</span>
            <span>{{ entry.value }}</span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

const extractValues = customer => {
  const cfv = customer?.attributes?.customFieldValues || customer?.customFieldValues
  const data = cfv?.data || cfv || []
  if (!Array.isArray(data)) return []

  return data.map(v => {
    const a = v?.attributes || v || {}

    return {
      customerCustomFieldId: a.customerCustomFieldId,
      value: a.typedValue != null ? a.typedValue : a.value,
    }
  })
}

export default {
  name: 'CustomerCustomFieldList',
  props: {
    customer: { type: Object, required: true },
    customFields: { type: Array, default: () => [] },
    inline: { type: Boolean, default: false },
  },
  setup(props) {
    const entries = computed(() => {
      const values = extractValues(props.customer)
      if (values.length === 0) return []

      return props.customFields
        .map(field => {
          const matched = values.find(
            v => Number(v.customerCustomFieldId) === Number(field.id),
          )
          if (!matched || matched.value == null || matched.value === '') return null

          return {
            id: field.id,
            name: field.name,
            value: matched.value,
          }
        })
        .filter(Boolean)
    })

    return { entries }
  },
}
</script>
